// src/utils/fileLoaders.js
import { fetchCMAMTOFERDAFiles, fetchCMAMTOFERDAFileById } from "api/CMAMTOFERDAFileApi";

import { fetchCNASTDERDAFiles, fetchCNASTDERDAFileById } from "api/CNASTDERDAFileApi";

import { fetchCNASTDNRAFiles, fetchCNASTDNRAFileById } from "api/CNASTDNRAFileApi";

import { fetchCNASTDPIGEFiles, fetchCNASTDPIGEFileById } from "api/CNASTDPIGEFileApi";

import { fetchCNASTDPIXEFiles, fetchCNASTDPIXEFileById } from "api/CNASTDPIXEFileApi";

import { fetchCNASTDRBSFiles, fetchCNASTDRBSFileById } from "api/CNASTDRBSFileApi";

import { fetchCNAuBIBICFiles, fetchCNAuBIBICFileById } from "api/CNAuBIBICFileApi";

import { fetchCNAuBPIXEFiles, fetchCNAuBPIXEFileById } from "api/CNAuBPIXEFileApi";

import { fetchCNAuBTRIBICFiles, fetchCNAuBTRIBICFileById } from "api/CNAuBTRIBICFileApi";

import { fileListByModelKeyAndProposal } from "api/FileApiRegistry";

// Mapea cada modelKey al par de funciones correspondientes
const fileApiMap = {
  cmam_toferda_files: {
    list: fetchCMAMTOFERDAFiles,
    detail: fetchCMAMTOFERDAFileById,
  },
  cna_std_erda_files: {
    list: fetchCNASTDERDAFiles,
    detail: fetchCNASTDERDAFileById,
  },
  cna_std_nra_files: {
    list: fetchCNASTDNRAFiles,
    detail: fetchCNASTDNRAFileById,
  },
  cna_std_pige_files: {
    list: fetchCNASTDPIGEFiles,
    detail: fetchCNASTDPIGEFileById,
  },
  cna_std_pixe_files: {
    list: fetchCNASTDPIXEFiles,
    detail: fetchCNASTDPIXEFileById,
  },
  cna_std_rbs_files: {
    list: fetchCNASTDRBSFiles,
    detail: fetchCNASTDRBSFileById,
  },
  cna_ub_ibic_files: {
    list: fetchCNAuBIBICFiles,
    detail: fetchCNAuBIBICFileById,
  },
  cna_ub_pixe_files: {
    list: fetchCNAuBPIXEFiles,
    detail: fetchCNAuBPIXEFileById,
  },
  cna_ub_tribic_files: {
    list: fetchCNAuBTRIBICFiles,
    detail: fetchCNAuBTRIBICFileById,
  },
  // Añade aquí los demás modelos según vayas implementándolos
};

export const loadLastFileByModelKey = async (modelKey, proposalId) => {
  try {
    const listByProposal = fileListByModelKeyAndProposal[modelKey];
    const detail = fileApiMap[modelKey]?.detail;

    if (!listByProposal || !detail) {
      console.warn(`Missing API mapping for modelKey: ${modelKey}`);
      return {};
    }

    const allFiles = await listByProposal(proposalId);
    if (!allFiles || allFiles.length === 0) return {};

    const sorted = allFiles.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    const lastFileId = sorted[0].id;

    const fullFile = await detail(lastFileId);
    return fullFile;
  } catch (error) {
    console.error(`Error loading last file for ${modelKey}:`, error);
    return {};
  }
};
